module.exports = __webpack_public_path__ + "static/img/p4.13b69dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productimg/p4.png
// module id = mcLa
// module chunks = 0